// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1DgwFJAtx{display:flex;max-width:100%;position:relative}._1DgwFJAtx ._2MFcOoObx{top:100%;left:0}._1DgwFJAtx ._1kMFcwZPx{left:100%;top:0}._1DgwFJAtx ._6sRQfT7Px{top:0}._1DgwFJAtx ._6sRQfT7Px._1kMFcwZPx{left:0}._1DgwFJAtx ._4mw1DGDax{transform:translateY(-50%)}._1DgwFJAtx .iSX0fIRIx{left:auto;right:0}._1DgwFJAtx .iSX0fIRIx._1kMFcwZPx{right:100%;left:auto}._1DgwFJAtx ._6Y7F3B6lx{left:auto;right:auto}._1DgwFJAtx ._5aa7duMtx{bottom:100%;top:auto}._1DgwFJAtx ._5aa7duMtx._1kMFcwZPx{bottom:0}._1DgwFJAtx ._5aa7duMtx._6sRQfT7Px{top:auto;bottom:0}._1DgwFJAtx ._5aa7duMtx.iSX0fIRIx._1kMFcwZPx{top:auto;bottom:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"positioner": "_1DgwFJAtx",
	"positioned": "_2MFcOoObx",
	"horizontal": "_1kMFcwZPx",
	"overlap": "_6sRQfT7Px",
	"v-center": "_4mw1DGDax",
	"vCenter": "_4mw1DGDax",
	"right": "iSX0fIRIx",
	"h-center": "_6Y7F3B6lx",
	"hCenter": "_6Y7F3B6lx",
	"upward": "_5aa7duMtx"
};
module.exports = exports;
